document.addEventListener("DOMContentLoaded", function () {
  const featuredSections = document.querySelectorAll(
    ".featured-collection-carousel"
  );
  const recommendationSections = document.querySelectorAll(
    ".product-recommendations-carousel"
  );
  if (!featuredSections.length && !recommendationSections.length) return;

  const swiperEnabled = typeof Swiper !== "undefined";
  const mobileQuery = window.matchMedia("(max-width: 749px)");

  const getGapValue = (element) => {
    const styles = getComputedStyle(element);
    const gapValue = parseFloat(styles.columnGap || styles.gap || "0");
    return Number.isNaN(gapValue) ? 0 : gapValue;
  };

  const initVariantSlider = (card) => {
    const variantsInner = card.querySelector(
      ".featured-collection-card__variants-inner"
    );
    if (!variantsInner) return;

    const variantButtons = Array.from(
      variantsInner.querySelectorAll(".featured-collection-card__variant")
    );
    const total = variantButtons.length;
    if (!total) return;

    const variantsTrack = variantsInner.closest(
      ".featured-collection-card__variants-track"
    );
    if (variantsTrack) {
      variantsTrack.classList.toggle("has-overflow", total > 6);
    }

    const visibleCount = Math.min(6, total);
    const buttonWidth = variantButtons[0].getBoundingClientRect().width || 0;
    const step = buttonWidth + getGapValue(variantsInner);

    const updateSliderPosition = (activeIndex) => {
      if (total <= visibleCount || !step) {
        variantsInner.style.transform = "translateX(0px)";
        return;
      }

      let startIndex = 0;

      if (activeIndex >= 3) {
        startIndex = Math.min(activeIndex - 2, total - visibleCount);
      }

      variantsInner.style.transform = `translateX(${-startIndex * step}px)`;
    };

    updateSliderPosition(0);
    variantButtons.forEach((btn, index) => {
      btn.addEventListener("click", () => updateSliderPosition(index));
    });
  };

  const initCard = (card) => {
    const img = card.querySelector(".featured-collection-card__image");
    if (!img) return;

    const primarySrc = card.dataset.primaryImage;
    const secondarySrc = card.dataset.secondaryImage || "";

    card.addEventListener("mouseenter", () => {
      const activeVariantImage = card.dataset.activeVariantImage;
      if (activeVariantImage) {
        img.src = activeVariantImage;
      } else if (secondarySrc) {
        img.src = secondarySrc;
      }
    });

    card.addEventListener("mouseleave", () => {
      img.src = card.dataset.activeVariantImage || primarySrc;
    });

    const variantButtons = card.querySelectorAll(
      ".featured-collection-card__variant"
    );

    variantButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();

        const variantImage = btn.dataset.variantImage;
        if (!variantImage) return;

        img.src = variantImage;
        card.dataset.activeVariantImage = variantImage;

        variantButtons.forEach((button) => button.classList.remove("active"));
        btn.classList.add("active");
      });
    });

    initVariantSlider(card);
  };

  const initCardsInSection = (section) => {
    const cards = section.querySelectorAll(".featured-collection-card");
    cards.forEach((card) => initCard(card));
  };

  const initFeaturedSection = (section) => {
    const autoplayDelay = parseInt(section.dataset.autoplayDelay, 10) || 12000;
    const sliderEnabled = section.dataset.sliderEnabled !== "false";
    const swiperEl = section.querySelector(".swiper");
    if (!swiperEl || !swiperEnabled || !sliderEnabled) {
      initCardsInSection(section);
      return;
    }

    const fastSpeed = 600;
    const slowSpeed = autoplayDelay;

    const swiper = new Swiper(swiperEl, {
      loop: true,
      centeredSlides: false,
      slidesPerView: 1.25,
      spaceBetween: 8,
      speed: slowSpeed,
      allowTouchMove: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: true,
      },
      navigation: false,
      breakpoints: {
        750: {
          slidesPerView: 2.2,
          spaceBetween: 8,
        },
        990: {
          slidesPerView: 3.2,
          spaceBetween: 8,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 8,
        },
      },
      on: {
        slideChangeTransitionEnd: function () {
          this.params.speed = slowSpeed;
          this.setTransition(slowSpeed);
        },
      },
    });

    const navNext = section.querySelector(
      ".featured-collection-carousel__nav-btn--next"
    );
    const navPrev = section.querySelector(
      ".featured-collection-carousel__nav-btn--prev"
    );

    if (navNext) {
      navNext.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        swiper.params.speed = fastSpeed;
        swiper.setTransition(fastSpeed);
        swiper.slideNext();
      });
    }

    if (navPrev) {
      navPrev.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        swiper.params.speed = fastSpeed;
        swiper.setTransition(fastSpeed);
        swiper.slidePrev();
      });
    }

    section.addEventListener("mouseenter", () => {
      swiper.autoplay.stop();
    });

    section.addEventListener("mouseleave", () => {
      swiper.autoplay.start();
    });

    initCardsInSection(section);
  };

  const initRecommendationsSwiper = (section) => {
    if (!swiperEnabled) return;

    const swiperEl = section.querySelector(".swiper");
    if (!swiperEl) return;

    if (section.swiperInstance) {
      section.swiperInstance.update();
      return;
    }

    section.swiperInstance = new Swiper(swiperEl, {
      loop: false,
      centeredSlides: false,
      slidesPerView: 1.1,
      spaceBetween: 8,
      speed: 600,
      allowTouchMove: true,
      navigation: false,
      breakpoints: {
        750: {
          slidesPerView: "auto",
          spaceBetween: 8,
        },
      },
    });
  };

  const initRecommendationSection = (section) => {
    const setup = () => {
      initCardsInSection(section);
      initRecommendationsSwiper(section);
    };

    if (section.querySelector(".featured-collection-card")) {
      setup();
    } else {
      const recommendationsEl = section.querySelector("product-recommendations");
      if (!recommendationsEl) return;
      const observer = new MutationObserver(() => {
        if (section.querySelector(".featured-collection-card")) {
          observer.disconnect();
          setup();
        }
      });
      observer.observe(recommendationsEl, { childList: true, subtree: true });
    }

    if (swiperEnabled) {
      mobileQuery.addEventListener("change", () =>
        initRecommendationsSwiper(section)
      );
    }
  };

  featuredSections.forEach((section) => initFeaturedSection(section));
  recommendationSections.forEach((section) => initRecommendationSection(section));
});
